export enum CardTypes {
    Visa = 'visa',
    MasterCard = 'mastercard',
    Amex = 'americanexpress',
    Stripe = 'stripe',
    JCB = 'jcb',
    Discover = 'discover',
    ApplePay = 'apple-pay',
    AmazonPay = 'amazon-pay',
    Paypal = 'paypal',
    DinersClub = 'diners-club',
}
